import store from '@/uteis/store'
import VirtusService from '@/services/VirtusService'
import md5 from 'md5'

const generateSecurityKey = (value) => {
  const documento = JSON.stringify(value)
  const currentDate = (new Date()).valueOf().toString()

  const securityKey = md5(documento + currentDate)
  return securityKey
}

export const criarNovoDocumento = async (processo) => {
  const virtusService = new VirtusService()
  const resp = await virtusService.getNumeroProtocoloDocumento()
  const numeroProtocoloDocumento = resp.dados[0]
  const numeroProcesso = processo.numeroProcesso.numeroProcessoFormatado

  const documento = store.getters.getDocumento
  const {
    especie, numeroAnexos, complementoSetor, sigiloso, tipoDocumento
  } = store.getters.getProcesso
  const sessao = store.getters.getDadosSessao.sessao

  const dataProducao = documento.dataProducao.replace(/(\d{4})-(\d{2})-(\d{2})/, '$3/$2/$1')
  const now = new Date()
  const dataHoraSolicitacao = `${now.toLocaleDateString()} ${now.toLocaleTimeString()}`
  const sigilosoText = sigiloso === 'SIM' ? 'Sim' : 'Não'
  const tipoDocumentoText = tipoDocumento === 'SIMPLES' ? 'Simples' : 'Composto'
  const volume = processo.numeroProcesso.tipoProtocolo === 'PROCESSO' ? 1 : null

  const model = {
    anexos: [],
    autor: {
      nome: sessao.nomeUsuario,
      identificador: sessao.login,
      tipoIdentificador: 'LOGIN'
    },
    chaveCategoria: 'EXTERNO',
    tipoMeio: 'DIGITAL',
    protocolo: numeroProtocoloDocumento,
    numeroProcesso: numeroProcesso,
    atributos: {
      ...documento,
      protocolo: numeroProtocoloDocumento,
      usuarioSessao: sessao.nomeUsuario,
      dataHoraSolicitacao: dataHoraSolicitacao,
      data: dataProducao,
      numeroProcesso: processo.numeroProcesso.numeroProcessoFormatado,
      documento: tipoDocumentoText,
      descricaoOrgao: sessao.descricaoOrgao,
      descricaoDepartamento: sessao.descricaoDepartamento,
      sigiloso: sigilosoText,
      assunto: especie.assunto,
      especie: especie.especie,
      codigoEspecie: especie.codigoEspecie.toString(),
      codigoAssunto: especie.assunto.codigoAssunto,
      numeroAnexos: numeroAnexos.toString(),
      observacoes: complementoSetor,
      quantidadeDocumentos: '1',
      nomeAssunto: especie.assunto.assunto
    }
  }

  if (volume) {
    model.atributos.volume = volume.toString()
  }

  const securityKey = generateSecurityKey(model)
  model.atributos.securityKey = securityKey

  await virtusService.criarDocumento(model)

  return processo
}
